export const logoLists = [
  [
    {
      title: "openeuler",
      logo: "//files.authing.co/authing-website/home-0830-logo-1-k.png",
    },
    {
      title: "中国石油",
      logo: "//files.authing.co/authing-website/home-0830-logo-2-k.png",
      clickUrl: "https://www.authing.cn/customer/cnpn",
    },
    {
      title: "东南大学",
      logo: "//files.authing.co/authing-website/home-0830-logo-3-k.png",
      clickUrl: "https://www.authing.cn/customer/southeast-university",
    },
    {
      title: "高等教育出版社",
      logo: "//files.authing.co/authing-website/home-0830-logo-4-k.png",
      clickUrl: "https://www.authing.cn/customer/hep",
    },
    {
      title: "招商银行",
      logo: "//files.authing.co/authing-website/home-0830-logo-5-k.png",
    },
    {
      title: "大众",
      logo: "//files.authing.co/authing-website/home-0830-logo-6-k.png",
      clickUrl: "https://www.authing.cn/customer/volkswagen",
    },
    {
      title: "明宇集团",
      logo: "//files.authing.co/authing-website/home-0830-logo-7-k.png",
    },
    {
      title: "PingCAP",
      logo: "//files.authing.co/authing-website/home-0830-logo-8-k.png",
      clickUrl: "https://www.authing.cn/customer/pingcap",
    },
    {
      title: "德高集团",
      logo: "//files.authing.co/authing-website/home-0830-logo-10-k.png",

      clickUrl: "https://www.authing.cn/customer/jcdecaux",
    },
    {
      title: "元气森林",
      logo: "//files.authing.co/authing-website/home-0830-logo-9-k.png",
      clickUrl: "https://www.authing.cn/customer/yuanqi",
    },
    {
      title: "长鑫存储",
      logo: "//files.authing.co/authing-website/home-0830-logo-11-k.png",
    },
  ],
  [
    {
      title: "可口可乐",
      logo: "//files.authing.co/authing-website/home-0830-logo-12-k.png",
    },
    {
      title: "科锐国际",
      logo: "//files.authing.co/authing-website/home-0830-logo-13-k.png",
    },
    {
      title: "丰田",
      logo: "//files.authing.co/authing-website/home-0830-logo-14-k.png",
      clickUrl: "https://www.authing.cn/customer/toyota",
    },
    {
      title: "国家电网",
      logo: "//files.authing.co/authing-website/home-0830-logo-15-k.png",
    },
    {
      title: "宾利",
      logo: "//files.authing.co/authing-website/home-0830-logo-16-k.png",
      clickUrl: "https://www.authing.cn/customer/bentley-motors",
    },
    {
      title: "博世",
      logo: "//files.authing.co/authing-website/home-0830-logo-17-k.png",
      clickUrl: "https://www.authing.cn/customer/bosch",
    },
    {
      title: "光大银行",
      logo: "//files.authing.co/authing-website/home-0830-logo-18-k.png",
    },
    {
      title: "海底捞",
      logo: "//files.authing.co/authing-website/home-0830-logo-19-k.png",
    },
    {
      title: "现代保险",
      logo: "//files.authing.co/authing-website/home-0830-logo-20-k.png",
    },
    {
      title: "中国医师协会",
      logo: "//files.authing.co/authing-website/home-0830-logo-21-k.png",
    },
    {
      title: "声网",
      logo: "//files.authing.co/authing-website/home-0830-logo-22-k.png",
    },
  ],
];
